import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { Button, Table } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import FilterPannel from "../../filter/FilterPannel";
import moment from 'moment';
import CallAPI from "../../../api/CallAPI";

class HourlyCallReport extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model);
    const feedbackOptions = model.call.fields.feedback.options || [];
    const callStatusOptions = model.call.fields.call_status.options || [];
    const callDirectionOptions = model.call.fields.direction.options || [];
    const userOptions = model.user.options || [];

    this.headerArray = [
      { label: 'Dial', key: 'Dial' },
      { label: 'Total Talktime', key: 'Total_TalkTime' },
      { label: 'Avg TalkTime', key: 'Avg_TalkTime' },
    ];

    callStatusOptions.forEach(status => {
      this.headerArray.push({ label: status.label, key: status.label.replace(/\s+/g, '_') });
    });

    callDirectionOptions.forEach(direction => {
      this.headerArray.push({ label: direction.label, key: direction.label.replace(/\s+/g, '_') });
    });

    feedbackOptions.forEach(fd => {
      this.headerArray.push({ label: fd.label, key: fd.label.replace(/\s+/g, '_') });
    });

    const fields = model.call.fields;
    this.fields = { date_time: fields['date_time'], responsible_person: fields['responsible_person'] };
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      feedbackOptions,
      callDirectionOptions,
      userOptions,
      filters: [{
        "field": "date_time",
        "condition": "in",
        "value": `${moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')}~${moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')}`
      }],
      tableData: [],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount() {
    this.fetchApi(this.state.filters, this.onSuccess, this.onFail);
  }

  fetchApi = (filters, onSuccess, onFail) => {
    this.setState({ inApiCall: true });
    CallAPI.getFixedCallStatusByHourReportList(filters, onSuccess, onFail);
  };

  formatHourRange(hour) {
    const start = moment.utc().startOf('day').add(hour, 'hours').utcOffset(5.5 * 60); // IST
    const end = moment.utc().startOf('day').add(hour + 1, 'hours').utcOffset(5.5 * 60); // IST
    return `${start.format('h:mm A')} to ${end.format('h:mm A')}`;
  }

  formatDuration(seconds) {
    if (!seconds || isNaN(seconds) || seconds <= 0) return '0s';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    let result = '';
    if (hrs > 0) result += `${hrs}hr `;
    if (mins > 0) result += `${mins}m `;
    if (secs > 0) result += `${secs}s`;
    return result.trim();
  }

  parseData = (response) => {
    // UTC hours for IST 9AM → 8PM
    const startHour = 3;  // 9:00 IST
    const endHour = 15;   // 20:00 IST
    const responseMap = {};
    response.forEach(item => {
      responseMap[item.hour_start] = item;
    });

    const tableData = [];

    for (let h = startHour; h < endHour; h++) {
      const hourLabel = `${h.toString().padStart(2, '0')}:00`; // API hour in UTC
      const displayLabel = this.formatHourRange(h);           // IST display
      const item = responseMap[hourLabel] || {};

      const row = {};
      row['Hour'] = displayLabel;
      this.headerArray.forEach(({ label, key }) => {
        if (['Dial', 'Incoming', 'Outgoing'].includes(label)) {
          row[label] = item[key] || 0;
        } else if (label === 'Total Talktime') {
          const seconds = Number(item[key]) || 0;
          row[`_${label}_seconds`] = seconds;
          row[label] = this.formatDuration(seconds);
        } else if (label === 'Avg TalkTime') {
          const seconds = Number(item[key]) || 0;
          row[`_${label}_seconds`] = seconds;
          row[label] = this.formatDuration(seconds);
        } else {
          row[label] = item[key] || 0;
        }
      });

      tableData.push(row);
    }

    // Totals
    const totalsRow = { Hour: 'Total' };
    const totalTalktimeSeconds = tableData.reduce((sum, row) => sum + (row['_Total Talktime_seconds'] || 0), 0);
    const avgTalktimeSeconds = tableData.length > 0
      ? Math.floor(tableData.reduce((sum, row) => sum + (row['_Avg TalkTime_seconds'] || 0), 0) / tableData.length)
      : 0;

    this.headerArray.forEach(({ label }) => {
      if (label === 'Total Talktime') totalsRow[label] = this.formatDuration(totalTalktimeSeconds);
      else if (label === 'Avg TalkTime') totalsRow[label] = this.formatDuration(avgTalktimeSeconds);
      else totalsRow[label] = tableData.reduce((sum, row) => sum + (parseInt(row[label]) || 0), 0);
    });

    tableData.push(totalsRow);
    return { tableData };
  };

  onSuccess = (data) => {
    const { tableData } = this.parseData(data);
    this.setState({ tableData, exportData: tableData, inApiCall: false });
  };

  onFail = (err) => console.log("Failed to fetch data", err);

  toggleFilter = () => this.setState(prev => ({ isFilterOpen: !prev.isFilterOpen }));

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters }, () => {
      this.fetchApi(this.state.filters, this.onSuccess, this.onFail);
    });
  };

  render() {
    const { exportData, filters, isFilterOpen, inApiCall, userOptions, tableData } = this.state;

    let selectedUserId;
    filters.map(f => f.field === 'responsible_person' ? selectedUserId = f.value.split(Constants.Opt).filter(Boolean) : null);
    const filteredUserOptions = userOptions.filter(user => {
      if (Boolean(selectedUserId)) return selectedUserId.some(id => parseInt(id) === user.value);
      return true;
    });

    const table = (
      <Table bordered hover>
        <thead>
          <tr>
            <th></th>
            {this.headerArray.map((h, i) => <th key={i}>{h.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, i) => (
            <tr key={i}>
              <td>{row.Hour}</td>
              {this.headerArray.map((h, j) => <td key={j}>{row[h.label]}</td>)}
            </tr>
          ))}
        </tbody>
      </Table>
    );

    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid p-3">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6"><h1>Hourly Call Report</h1></div>
                <div className="col-md-6">
                  <CSVLink data={exportData} filename="call_By_feedback_By_salesPerson_report.csv">
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">{filters.length}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                  <div className="col-md-12">{table}</div>
                </div>
                {isFilterOpen && (
                  <FilterPannel
                    filters={filters}
                    fields={this.fields}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={isFilterOpen}
                    restrict={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default HourlyCallReport;
